export function computeColumnCounts(cells, emptyColumnHandling) {
    // default: always use 12 columns, empty columns are empty space
    if (emptyColumnHandling === "includeEmpty") {
        return 12;
    }
    // if there are size overrides, disable the feature
    if (cells.some((cell) => cell.sizes != null)) {
        return 12;
    }
    // simplify to a single value
    return cells.reduce((acc, cell) => { var _a; return acc + ((_a = cell.size) !== null && _a !== void 0 ? _a : 1); }, 0);
}
//# sourceMappingURL=computeColumnCounts.js.map